const c = {
  name: "HandsSwear",
  dimensions: { width: 26, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 26 39.8" style="enable-background:new 0 0 26 39.8;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3.1,13.3l-2.9,8.1l0,0C0.1,21.8,0,22.3,0,22.8v4c0,7.2,5.8,13,13,13c7.2,0,13-5.8,13-13v-9c0-2.2-1.8-4-4-4
			c-0.8,0-1.6,0.2-2.2,0.7c-0.5-1.6-2-2.7-3.8-2.7c-1.8,0-3.4,1.2-3.9,2.9l-0.5-1.4l2.1-5.8c0.8-2.1-0.3-4.4-2.4-5.1
			c-1.2-0.5-2.5-0.3-3.6,0.4l0-0.1l0,0C7,0.6,4.7-0.5,2.6,0.2l0,0C0.6,1-0.5,3.3,0.2,5.4L3.1,13.3z M2.1,4.7c-0.4-1,0.2-2.2,1.2-2.6
			c1-0.4,2.2,0.2,2.6,1.2l0.4,1.2c0,0.1-0.1,0.1-0.1,0.2l-2,5.7L2.1,4.7z M8.1,5.4c0.4-1,1.5-1.6,2.6-1.2c1,0.4,1.6,1.5,1.2,2.6
			l-4.4,12H4c-0.2,0-0.5,0-0.7,0.1L8.1,5.4L8.1,5.4z M9.7,18.8l0.9-2.5l1.1,2.9c-0.5-0.2-1-0.3-1.6-0.3H9.7z M13,25.4
			c0.7,0.8,1.8,1.4,3,1.4c1.7,0,3.2-1.1,3.8-2.7c0.6,0.4,1.4,0.7,2.2,0.7c0.7,0,1.4-0.2,2-0.5v2.5c0,6.1-4.9,11-11,11
			c-6.1,0-11-4.9-11-11v-4c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2s-0.9,2-2,2H6v2h4C11.2,26.8,12.3,26.2,13,25.4z M20,20.8v-3
			c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v3c0,1.1-0.9,2-2,2C20.9,22.8,20,21.9,20,20.8z M18,15.8v7c0,1.1-0.9,2-2,2s-2-0.9-2-2v-7
			c0-1.1,0.9-2,2-2S18,14.7,18,15.8z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as HandsSwear
};
